import React from 'react';
import { base64Kit } from '@/utils/base64-kit';
import { createCanvas, loadImageAsync } from '@/utils/file-kit';
import { computerImageTransform } from '@/utils/layer-kit';
import {
    IExportBehavior,
    IImageLayerProps,
    IImageProps,
    ILayerBehavior,
    ILayerProps,
    IMAGE_LAYER_CANVAS_ID_PREFIX,
    IRenderLayerExtraProps,
    ISize,
    LayerType,
} from '@/version-types';
import { handleBeforeSave } from './actions/handle-before-save';
import MainLayer from './views/layer';
import { renderLayerToStage } from './views/render-to-stage';

function getBehavior(identity: string) {
    const layerBehavior: ILayerBehavior = {
        render(layer: ILayerProps, extraProps: IRenderLayerExtraProps) {
            return <MainLayer layer={layer} {...extraProps} />;
        },

        onBeforeAddOrUpdate(layer: ILayerProps) {
            const data = layer.data as IImageProps;
            data.url = base64Kit.getCode(data.url);
        },
        async onBeforeSaveAsync(layer: ILayerProps, isAutoSave?: boolean) {
            return handleBeforeSave(layer, isAutoSave);
        },
        async getResultCanvasAsync(layer: ILayerProps, stageSize: ISize): Promise<HTMLCanvasElement | undefined> {
            // TODO: 多实例下 id 冲突问题解决
            const domCanvas = document.getElementById(
                `${IMAGE_LAYER_CANVAS_ID_PREFIX}${layer.id}`,
            ) as HTMLCanvasElement;

            return renderLayerToStage(identity, layer, domCanvas, stageSize);
        },
        checkDisableCollision(): boolean {
            return true;
        },
        checkDisableInGroup(): boolean {
            return true;
        },
        checkDisableFlip() {
            return true;
        },
        isMainLayer() {
            return true;
        },
        adjustResize(layer: ILayerProps, newWidth: number, newHeight) {
            const data = layer.data as IImageLayerProps;

            layer.height = newHeight;
            layer.width = newWidth;

            if (!data.url) return;

            computerImageTransform(newWidth, newHeight, data);
        },
        checkDisableActive(): boolean {
            return true;
        },
    };
    return layerBehavior;
}

const exportBehavior: IExportBehavior = {
    layerType: LayerType.MAIN_LAYER,
    getBehavior,
};

export default exportBehavior;
